import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import {OptionExpirationDescriptor} from "../shell-communication/shell-dto-protocol";
import {DetectMethodChanges, DetectSetterChanges, DxValueChanged, isVoid} from "../utils";
import {MessageBusService} from "../message-bus.service";

export interface ExpirationChangeEvent {
    value: OptionExpirationDescriptor;
    previousValue: OptionExpirationDescriptor;
    event: string;
}

export interface ExpirationColorRankProvider {
    getExpirationColorRank(expiration: OptionExpirationDescriptor): number;
}

@Component({
    selector: 'ets-expiration-selector',
    templateUrl: './expiration-selector.component.html',
    styleUrls: ['./expiration-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpirationSelectorComponent implements OnInit {

    constructor(
        private _changeDetector: ChangeDetectorRef,
        private _messageBus: MessageBusService,
    ) {
    }

    private _refreshFlag = false;

    private _expirationDescriptors: OptionExpirationDescriptor[] = [];
    get expirationDescriptors(): OptionExpirationDescriptor[] {
        return this._expirationDescriptors;
    }

    @Input()
    @DetectSetterChanges()
    set expirationDescriptors(value: OptionExpirationDescriptor[]) {
        this._expirationDescriptors = value;
    }


    private _selectedExpiration: OptionExpirationDescriptor;
    get selectedExpiration(): OptionExpirationDescriptor {
        return this._selectedExpiration;
    }
    @Input()
    @DetectSetterChanges()
    set selectedExpiration(value: OptionExpirationDescriptor) {
        if (!isVoid(value)) {
            if (!value.visible) {
                value = null;
            }
        }

        const previousValue = this._selectedExpiration;

        this._selectedExpiration = value;

        if (!this._refreshFlag) {
            this.selectedExpirationChange.emit(value);
        } else {
            console.assert(this.selectedExpiration === value, 'expirations same');
        }

        this._refreshFlag = false;
    }

    private _disabled = false;
    get disabled(): boolean {
        return this._disabled;
    }
    @Input()
    @DetectSetterChanges()
    set disabled(value: boolean) {
        this._disabled = value;
    }

    private _showClearButton = false;
    get showClearButton(): boolean {
        return this._showClearButton;
    }
    @Input()
    @DetectSetterChanges()
    set showClearButton(value: boolean) {
        this._showClearButton = value;
    }

    @Output()
    selectedExpirationChange = new EventEmitter<OptionExpirationDescriptor>();

    @Output()
    expirationChanged = new EventEmitter<ExpirationChangeEvent>();

    @Input()
    readOnly = false;

    @Input()
    inputAttr: any;

    @Input()
    placeholder: string;

    @Input()
    extraData: any;

    ngOnInit(): void {

        this._messageBus.of<any>('Qg.ChainsUpdatedMessage')
            .pipe(
                // TODO
            )
            .subscribe(() => {
                this.onQgChainsUpdatedMessage();
            });
    }

    @DetectMethodChanges()
    private onQgChainsUpdatedMessage() {
        // Disabled to fix QG history mode issue when jumping over dates

        // this._refreshFlag = true;
        //
        // const copy = this._selectedExpiration;
        //
        // this._selectedExpiration = null;
        //
        // setTimeout(() => {
        //     this._selectedExpiration = copy;
        //     this._changeDetector.detectChanges();
        // });
    }

    onValueChanged($event: any) {
        this.expirationChanged.emit($event as any);
    }

    getExpirationColor(expiration: OptionExpirationDescriptor) {
        if (isVoid(expiration)) {
            return null;
        }

        if (isVoid(this.extraData?.position)) {
            return null;
        }

        if (isVoid(this.extraData?.colorRankProvider)) {
            return null;
        }

        const rankColor = this.extraData.colorRankProvider.getExpirationColorRank(expiration, this.extraData.position);

        return rankColor;
    }

    getText() {
        return this.selectedExpiration?.dateWithDaysToExpiration;
    }
}